/* eslint-disable no-await-in-loop */
import delay from 'delay';

import { ensureHazardAndPhysical } from './ensureHazardAndPhysical.js';
import { ensureSmiles } from './ensureSmiles.js';
import { normalizeQuantities } from './normalizeQuantities.js';

export async function prepareReagents(reagents, options = {}) {
  reagents = JSON.parse(JSON.stringify(reagents));
  for (const reagent of reagents) {
    normalizeQuantities(reagent, options);
    ensureSmiles(reagent);
    // need to be slow otherwise we will be blocked by pubchem
    await ensureHazardAndPhysical(reagent, options);
    await delay(500);
    reagent.safety = {};
  }

  return reagents;
}
